__turbopack_context__.v({
  "container": "portfolioContent-module-scss-module___tgEpG__container",
  "overlay": "portfolioContent-module-scss-module___tgEpG__overlay",
});
